import bnr_default from "./../assets/images/banner/bnr_default.jpg";
import bnr_show_room from "./../assets/images/banner/bnr_show-room.jpg";
import slider_1 from "./../assets/images/banner/slider/1.jpg";
import slider_2 from "./../assets/images/banner/slider/2.jpg";
import slider_3 from "./../assets/images/banner/slider/3.jpg";

import bnr_receipt from "./../assets/images/banner/bnr_receipt.jpg";
import access_denied from "./../assets/images/access_denied.png";

export default {
  slider_1,
  slider_2,
  slider_3,
  bnr_default,
  bnr_show_room,
  bnr_receipt,
  access_denied,
};
